import React from 'react';
import CheckIcon from '../assets/icons/check.svg';
import SignatureVector from '../assets/images/Vector.svg';

const INTRO_TEXT = 'Deze aanbevelingen zijn opgesteld door';

function addOneDay(resultDate) {
  const raw = String(resultDate || '').trim();
  if (!raw) return '';

  // Supports dd/mm/yyyy or dd.mm.yyyy from API mapping.
  const normalized = raw.replaceAll('.', '/');
  const parts = normalized.split('/');
  if (parts.length === 3) {
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);
    if (
      Number.isFinite(day) &&
      Number.isFinite(month) &&
      Number.isFinite(year)
    ) {
      const dt = new Date(year, month - 1, day);
      if (!Number.isNaN(dt.getTime())) {
        dt.setDate(dt.getDate() + 1);
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const yyyy = String(dt.getFullYear());
        return `${dd}.${mm}.${yyyy}`;
      }
    }
  }

  return raw;
}

function DoctorApprovalCard({ doctor, resultDate }) {
  const signedDate = addOneDay(resultDate);
  return (
    <div className="rounded-t-2xl -mr-[4px] mb-0 border border-[#f5f5f5] overflow-hidden">
      {/* Introductory Text */}
      <div className="bg-[#E7E7E7] p-4">
        <p className="text-[12px] md:text-[14px] font-poppins text-[#2B3133] text-center">
          {INTRO_TEXT}{' '}
          <br />
          <span className="font-semibold">{doctor.name}</span>
        </p>
      </div>
      
      {/* Main Content: Image on Left, Details and Signature on Right */}
      <div className="flex items-start gap-4 p-4">
        {/* Profile Picture - Larger on Left */}
        <div className="flex-shrink-0 w-24 h-24 md:w-32 md:h-32 rounded-full bg-[#E5E5E5] flex items-center justify-center overflow-hidden">
          <img
            src={doctor.photoUrl || `${process.env.PUBLIC_URL}/doctor-avatar.svg`}
            alt={doctor.name}
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Right Side: Details and Signature */}
        <div className="min-w-0 flex-1 flex flex-col">
          {/* Doctor Details */}
          <div className="flex flex-col gap-2 mb-3">
            <p className="text-[12px] md:text-[14px] font-poppins">
              <span className="text-[#889696]">BIG nummer:</span>{' '}
              <br />
              <span className="font-semibold text-[#2B3133]">{doctor.bigNumber}</span>
            </p>
            <p className="text-[12px] md:text-[14px] font-poppins">
              <span className="text-[#889696]">Digitaal ondertekend op:</span>{' '}
              <br />
              <span className="font-semibold text-[#2B3133]">{signedDate}</span>
            </p>
          </div>
          
          {/* Digital Signature */}
          <div className="w-full h-10 flex">
            <img
              src={SignatureVector}
              alt="Digital Signature"
              className="h-full w-auto object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function DoctorRecommendations({ items, resultDate, doctor }) {
  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <img src={CheckIcon} alt="check" className="w-[31.25px] h-[30px]" />
        <h3 className="text-xl font-poppins font-semibold text-[#2B3133]">
          Doctor Recommendations
        </h3>
      </div>
      {doctor && (
        <div className="block">
          <DoctorApprovalCard doctor={doctor} resultDate={resultDate} />
        </div>
      )}
      <div
        className={`${doctor ? 'rounded-b-2xl' : 'rounded-2xl'} p-6 mt-0 -mr-[4px]`}
        style={{ backgroundColor: '#EEFBF7' }}
      >
        <div className="space-y-6">
          {items.map((rec, index) => (
            <div
              key={index}
              className="pb-6 border-b border-[#C1DCD4] last:border-b-0 last:pb-0"
            >
              <h4 className="font-poppins font-semibold text-[#2B3133] mb-3">
                {rec.title}
              </h4>
              <div
                className="text-sm text-[#2B3133] leading-relaxed"
                dangerouslySetInnerHTML={{ __html: rec.content }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
